import { t } from "i18next";
import styled from "styled-components";
import { DatePickerText } from "../../../core/components/input/DatePickerText";
import { PhoneNumberInput } from "../../../core/components/input/PhoneNumberInput";
import { TextInput } from "../../../core/components/input/TextInput";
import { InfoText } from "../../../core/components/texts/InfoText";
import { Body } from "../../../core/styles/stringStyles";
import { hexWithOpacity } from "../../../core/utils/hexWithOpacity";
import { AppointmentScreenWrapper } from "../../onboarding/AppointmentScreenWrapper";

type Props = {
  headline?: string;
  subtitle?: string;
  handleNext: () => void;
  data: {
    firstName?: string;
    lastName?: string;
    email?: string;
    birthday?: string;
    nationalPhone?: string;
    countryCode?: string;
  };
  setData: {
    setAppointmentFirstName: (value: string) => void;
    setAppointmentLastName: (value: string) => void;
    setAppointmentEmail: (value: string) => void;
    setAppointmentBirthday: (value: string) => void;
    setAppointmentNationalPhone: (value: string) => void;
    setAppointmentCountryCode: (value: string) => void;
  };
  showEmail: boolean;
  showBirthday: boolean;
  birthdayRequired: boolean;
  nextButtonText?: string;
  loading?: boolean;
};

export const AppointmentContactComponent = (props: Props) => {
  const {
    handleNext,
    data: { firstName, lastName, email, birthday, nationalPhone, countryCode },
    setData: {
      setAppointmentFirstName,
      setAppointmentLastName,
      setAppointmentEmail,
      setAppointmentBirthday,
      setAppointmentNationalPhone,
      setAppointmentCountryCode,
    },
    showEmail,
    showBirthday,
    birthdayRequired,
    loading,
    nextButtonText,
  } = props;

  return (
    <AppointmentScreenWrapper
      onNext={handleNext}
      nextButtonLoading={loading}
      nextButtonText={nextButtonText}
      nextButtonDisabled={
        !firstName ||
        !lastName ||
        (showEmail && !email) ||
        (showBirthday && birthdayRequired && !birthday) ||
        !nationalPhone ||
        !countryCode
      }
    >
      <InfoText
        headline={t("APPOINTMENT_CONTACT_HEADLINE")}
        text={[t("APPOINTMENT_CONTACT_DESCRIPTION")]}
      />
      <Content>
        <TextInput
          label={t("APPOINTMENT_FIRST_NAME")}
          value={firstName || ""}
          onChange={setAppointmentFirstName}
          withoutError
        />
        <TextInput
          label={t("APPOINTMENT_LAST_NAME")}
          value={lastName || ""}
          onChange={setAppointmentLastName}
          withoutError
        />
        {showBirthday && (
          <DatePickerText
            label={t("APPOINTMENT_BIRTHDAY")}
            date={birthday || ""}
            onChange={setAppointmentBirthday}
          />
        )}
        {showEmail && (
          <TextInput
            label={t("APPOINTMENT_EMAIL")}
            value={email || ""}
            onChange={setAppointmentEmail}
            withoutError
          />
        )}
        <StyledBody>{t("APPOINTMENT_CALLBACK_NUMBER")}</StyledBody>
        <PhoneNumberInput
          setPhoneNumber={setAppointmentNationalPhone}
          phoneNumber={nationalPhone || ""}
          setPhoneCountry={setAppointmentCountryCode}
          phoneCountry={countryCode || ""}
        />
      </Content>
    </AppointmentScreenWrapper>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const StyledBody = styled(Body)`
  color: ${({ theme }) => hexWithOpacity(theme.colors.dark, 0.6)};
`;
